<script>
  import axios from "axios"
  import { push, querystring } from "svelte-spa-router"
  import { onMount } from "svelte"
  import Footer from "../../../../Shared/footer.svelte"
  import Navbar from "../../../../Shared/Navbar/index.svelte"
  import Item from "./Components/item.svelte"
  import Loader from "../../../../Shared/Slots/loader.svelte"
  import ApplicationState from "../../../../Stores/applicationStates"
  import notify from "../../../../Script/notify"
  import Table from "../../../../Shared/Table/table.svelte"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import Filter from "../../../../Shared/filter.svelte"
  import { getRequest, postRequest } from "../../../../Script/apiMethods"

  /**
   * @type {String} text displayed with the svg loader while loading
   */
  let loadingText = "Fetching List of Email Templates&nbsp;"
  /**
   * @type {Boolean} for showing Loader while loading the list of Email templates
   */
  let showLoading = true
  /**
   * @typedef {Object} notification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {notification}
   */
  let notification = {
    close() {},
  }

  let emailCount

  let query

  let limit
  let page
  let sort
  let sortBy
  let search = {
    searchParam: "name",
    searchvalue: "",
  }
  let startDate = null
  let endDate = null
  let emailList = []

  onMount(async () => {
    try {
      query = queryStringToJSON($querystring)
      limit = query.limit ? query.limit : 10
      page = query.page ? query.page : 1
      sort = query.sort ? query.sort : -1
      sortBy = query.sortBy ? query.sortBy : "date"
      if (query.sdate) startDate = query.sdate
      if (query.edate) endDate = query.edate
      if (query.sname) search.searchvalue = query.sname
      // if (query.sin) search.searchParam ? query.sin : "name"
      await fetchTemplates()
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: onMount"
      notify.danger(error, info)
    }
  })

  const fetchTemplates = async () => {
    try {
      showLoading = true
      const { count, templates } = await getRequest(`/api/swagger/v2/templates/emails?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      emailCount = count
      emailList = templates
      push(`/templates/email?limit=${limit}&page=${page}&sort=${sort}&sortBy=${sortBy}${search.searchvalue ? `&sin=${search.searchParam}&sname=${search.searchvalue}` : ``}${startDate ? `&sdate=${startDate}` : ``}${endDate ? `&edate=${endDate}` : ``}`)
    } catch (error) {
      throw error
    } finally {
      showLoading = false
    }
  }

  /**
   *  @description function to create the new email template
   */
  const createEmailTemplate = async () => {
    try {
      showLoading = true
      loadingText = "Creating New Email Template&nbsp;"

      let requestBody = {
        name: "",
        document: undefined,
        documentName: "None",
        subject: "",
        headerText: "Test User",
        // headerURL: "https://print2block.com/img/logo1.png",
        headerURL: "",
        headerType: "text",
        headerFont: "",
        headerFontSize: 32,
        headerTextColor: "#ffffff",
        background: "#f7f7f7",
        headerBackground: "#005A9C",
        cardRadius: 5,
        cardPadding: 40,
        cardBackground: "#ffffff",
        cardWidth: 550,
        content: "<p>hi {{receiver_name}}<br><br>Your Blockchain secured document is available at {{url}}</p>",
      }

      const { template } = await postRequest("/api/swagger/v2/templates/emails", requestBody, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      //navigating to edit page
      push(`/templates/email/edit?id=${template.id}`)
      notification = notify.success("A new <strong>Email template</strong> has been created with default values.")
      // push(`/templates/email/edit?id=${data.template.id}&scroll="bottom"`)
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: While creating email template"
      notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }

  const whileChangingEntries = async (e) => {
    try {
      if (e.detail.entries) limit = e.detail.entries
      if (e.detail.activePage) page = e.detail.activePage
      if (e.detail.sort) sort = e.detail.sort
      if (e.detail.sortBy) sortBy = e.detail.sortBy
      startDate = e.detail.filter.date.startDate ? e.detail.filter.date.startDate : ""
      endDate = e.detail.filter.date.endDate ? e.detail.filter.date.endDate : ""
      if (e.detail.filter.search.searchParam) {
        search.searchParam = e.detail.filter.search.searchParam
        search.searchvalue = e.detail.filter.search.searchvalue
      }
      await fetchTemplates()
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: Error occurred during actions such as sorting by date/ name, changing display entries, changing date filter, searching by name, or navigating pages."
      notify.danger(error, info)
    }
  }
  
  const resetList = async () => {
    try {
      limit = 10
      page = 1
      sort = 1
      sortBy = "date"
      search.searchvalue = ""
      startDate = null
      endDate = null
      await fetchTemplates()
    } catch (error) {
      const info = "PAGE: Email template list\nEVENT: Error occurred while resetting filter."
      notify.danger(error, info)
    }
  }
</script>

<svelte:head>
  <title>Email Templates</title>
</svelte:head>

<div class="relative min-h-screen w-full overflow-x-hidden bg-[#f7f7f7] pb-24 dark:bg-bodyblack">
  <Navbar />

  {#if showLoading}
    <div class="flex min-h-[200px] items-center justify-center text-base text-gray-400">
      <Loader>
        <span class="flex">
          {@html loadingText}
        </span>
      </Loader>
    </div>
  {/if}
  <div class="px-6 pb-12 pt-3">
    <div class="relative mx-auto mt-8 h-full w-full max-w-[920px] rounded-md">
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div on:click={createEmailTemplate} class="absolute right-0 top-0 z-10 flex h-9 w-max min-w-[36px] cursor-pointer items-center justify-center rounded-md border border-transparent bg-blue-500 px-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none active:bg-blue-500">
        <span>
          <i class="fa-solid fa-plus" />
        </span>
        <span class="hidden sm:block">&nbsp;Add Email Template</span>
        <span class="block sm:hidden">&nbsp;Add</span>
      </div>

      <Table on:changeEntries={whileChangingEntries} on:resetEntries={resetList} title={"Email Templates"} filterComponent={Filter} jsonData={emailList} count={emailCount} filter={true}>
        {#if emailList.length}
          {#each emailList as Json}
            <Item
              count={emailCount}
              template={Json}
              bind:showLoading
              bind:loadingText
              on:fetchList={async () => {
                try {
                  await fetchTemplates()
                } catch (error) {
                  const info = "PAGE: Email template list\nEVENT: Error occurred while fetching email template list again after deletion/ duplication of email template."
                  notify.danger(error, info)
                }
              }}
            />
          {/each}
        {:else}
          <div class="text-secondary2 select-none rounded-md bg-white py-6 text-center text-2xl dark:bg-darkgray dark:text-white">There is no email template</div>
        {/if}
      </Table>
    </div>
  </div>
  <Footer />
</div>
